import { notificationCTPPreferenceGroups } from '../../../components/Notifications/Preferences/mock-CTP-data';
import { profileVisibility } from '../visibility/profileVisibility-mock';

const notificationsMockOverrides = {
  Candidate: () => ({
    id: 34712547,
    personalDetails: { firstName: 'Hulk', __typename: 'PersonalDetails' },
    emailCorrelationId: '9d1a874c-fac1-4c59-9557-ca028986d5bc',
    emailAddress: 'hulk@example.com',
    profileVisibility,
    notificationCTPPreferenceGroups,
    __typename: 'Candidate',
  }),
};

export default notificationsMockOverrides;
